<div class="unit-wrapper">
  <div class="unit-navigation">
    <img src="../../assets/back-arrow-icon.svg" alt="back navigation" />
    <div class="prev-page">Users</div>
    <img src="../../assets/forward-arrow-icon.svg" alt="back navigation" />
    <div class="forward-page" style="min-width:fit-content; padding-left:15px; padding-right:15px" >Add Temp User</div>
  </div>
  <div class="card add-unit">
    <h1 class="section-title">Add a New Temp User</h1>
    <p class="subtext">Fill out the User details using the form below.</p>
    <form
      #form="ngForm"
      (ngSubmit)="activateSubmitBtn() ? addTempUser() : null"
      style="margin-top: 2rem"
    >
      <div class="form-container">
        <!--company and plant-->
        <div class="input-container">
          <div class="input-item" *ngIf="currentRole === Roles.superAdmin">
            <label class="custom-label required">Account Holder Name</label>
            <app-dropdown
              [disabled]="true"
              [label]="selectedCompany.companyName"
            >
            </app-dropdown>
          </div>
          <div
            [ngStyle]="currentRole === Roles.admin ? specialStyle : defaultStyle"
            class="input-item"
          >
            <label class="custom-label required">Client Name</label>
            <app-dropdown [disabled]="true" [label]="selectedPlant.plantName">
            </app-dropdown>
          </div>
        </div>

        <label class="custom-label required">Group Name</label>
        <app-dropdown
          (onSelectOption)="handleSelectGroup($event)"
          [options]="groups"
          [fields]="['tempUserGroupId', 'groupName']"
          label="Choose Group"
        >
        </app-dropdown>

        <!--first name and last name-->
        <div class="input-container">
          <div class="input-item">
            <label class="custom-label required" for="fname">First Name</label>
            <input
              [(ngModel)]="firstName"
              type="text"
              class="custom-input"
              name="fname"
              id="fname"
            />
            <span *ngIf="showFirstNameError" class="unit-error">
              <img
                class="unit-icon"
                src="../../assets/error-icon.svg"
                alt="dropdown icon"
              />
              <div class="unit-error-text">
                {{ firstNameError }}
              </div>
            </span>
          </div>
          <div class="input-item">
            <label class="custom-label required" for="lname">Last Name</label>
            <input
              [(ngModel)]="lastName"
              type="text"
              class="custom-input"
              name="lname"
              id="lname"
            />
            <span *ngIf="showLastNameError" class="unit-error">
              <img
                class="unit-icon"
                src="../../assets/error-icon.svg"
                alt="dropdown icon"
              />
              <div class="unit-error-text">
                {{ lastNameError }}
              </div>
            </span>
          </div>
        </div>

        <!-- Email and Contact -->
        <div class="input-container">
          <div class="input-item">
            <label class="custom-label ">Contact Number</label>
            <input
			  [(ngModel)]="contact"
              type="text"
              class="custom-input"
              maxlength="16"
              name="contact"
              (input)="formatContact($event)"
              id="contact"
            />
            <span *ngIf="showContactError" class="unit-error">
              <img
                class="unit-icon"
                src="../../assets/error-icon.svg"
                alt="dropdown icon"
              />
              <div class="unit-error-text">{{ contactError }}</div>
            </span>
          </div>

          <div class="input-item">
            <label class="custom-label required" for="email">Email</label>
            <input
              [(ngModel)]="email"
              type="text"
              class="custom-input"
              name="email"
              id="email"
            />
            <span *ngIf="showEmailError" class="unit-error">
              <img
                class="unit-icon"
                src="../../assets/error-icon.svg"
                alt="dropdown icon"
              />
              <div class="unit-error-text">{{ emailError }}</div>
            </span>
          </div>
        </div>
      </div>

      <div class="btn-group">
        <a
          routerLink=".."
          [state]="[selectedCompany, selectedPlant, pageDetails]"
          class="btn-outline"
        >
          Cancel
        </a>
        <button
          *ngIf="!csvValidated || bulkUsers.length === 0"
          class="btn-fill"
          [ngClass]="!activateSubmitBtn() ? 'disabled-btn' : ''"
          type="submit"
        >
          Add User
        </button>
        <button
          *ngIf="csvValidated && bulkUsers.length > 0"
          class="btn-fill"
          [ngClass]="!activateBulkSubmitBtn() ? 'disabled-btn' : ''"
          type="button"
          (click)="submitBulkUsers()"
        >
          Upload {{ bulkUsers.length }} Users
        </button>
      </div>
      <div *ngIf="!errorMessage.success" class="error">
        <img src="../../assets/alert.svg" alt="" />
        <p>
          {{ errorMessage.message }}
        </p>
      </div>
    </form>
  </div>
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
